// extracted by mini-css-extract-plugin
export default {"MoonLight":"Theme_MoonLight__8pv7+","SunDark":"Theme_SunDark__QYqNE"};